import { HTTPStatusCodes } from 'constants/httpStatusCodes';

import {
  DECLINATION_REASONS_FIELD_NAMES,
  RETRYABLE_STATUS_CODES
} from './DeclinationReasons.constants';

export const getReasonDetailsFormValues = reasonDetails => ({
  [DECLINATION_REASONS_FIELD_NAMES.DeclinedFields]: reasonDetails?.reasonIds || [],
  [DECLINATION_REASONS_FIELD_NAMES.DeclinationNotes]: reasonDetails?.notes || ''
});

export const buildReasonDetailsPayload = ({ statusId, formValues }) => ({
  statusId,
  reasonDetails: {
    reasonIds: formValues?.[DECLINATION_REASONS_FIELD_NAMES.DeclinedFields] || [],
    notes: formValues?.[DECLINATION_REASONS_FIELD_NAMES.DeclinationNotes] || ''
  }
});

export const isRetryableStatusCode = statusCode =>
  !statusCode ||
  statusCode >= HTTPStatusCodes.InternalServerError ||
  RETRYABLE_STATUS_CODES.includes(statusCode);
